import { DOCUMENT } from '@angular/common';
import { Component, OnInit, Inject, Input } from '@angular/core';
import { HomepageService } from '../../services/homepage.service';
import { SearchService } from '../../services/search.service';
import { AuthService } from '../../services/auth.service';
import { CookieService } from 'ngx-cookie-service';
import {Router, ActivatedRoute, Params} from '@angular/router';
import { WidgetSettingsService } from '../../services/widget-settings.service';
import { NotifierService } from 'angular-notifier';
@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {
  @Input() public googleError: string = ''; 
  private readonly notifier: NotifierService;
  gloalSetting: any = [];
  isLogin: any;
  profileDetail : any = [];
  showProfileMenu :boolean = false;
  totalIds:any = 0;
  recentSearch: string = '';
  recentSearchCount: any = '0';
  logoChoose: any[] = [];
  logoChooseShow: boolean = false;
  noUploadedLogo: boolean = false;
  showMyListop: boolean = false;
  fileToUpload: File = null;
  currntUrl: string = '';
  searchSetting: any = [];
  publishToList: any = [];
  publishToOptionShow: boolean = false;
  patronId:any;
  patronName:any;
  curentLoc:any = [];
  publishResourceName:any ='';
  publishResourceConfirure:any = null;
  publishResourceDescription:any ='';
  publishResourceImage:any ='';
  publishResourceStatus : boolean = false;
  publishToListlist: any;
  totalLocations :any;
  publishDescriptionStatus :boolean = true;
  PulishFormReady: boolean = false;
  isUserLogin : boolean = false;
  imageError: string = '';
  showDeleteConfirm: boolean = false;
  data:any='';
  dateFormat:string = "M/d/yyyy";
  libraryCard :any = [];
  idImage: string;
  colors: string;
  imageName: string;
  screenHeight: number;
  screenWidth: number;
 constructor( @Inject(DOCUMENT) private document: Document, private homepageService: HomepageService,private cookieService: CookieService, private authService: AuthService, private router: Router, private activatedRoute: ActivatedRoute, private searchService: SearchService, private widgetSettingsService: WidgetSettingsService, notifierService: NotifierService) {
    this.notifier = notifierService;
  	this.router.events.subscribe((val) => {      
    this.recentSearchCount = this.cookieService.get( 'recentSearchCunt');   
    if( this.cookieService.check( 'MyLIstCount')){
      this.totalIds = this.cookieService.get( 'MyLIstCount');
      //console.log("my list =="+ this.totalIds);
    }
    });
    this.authService.logoutObservable$.subscribe(loggedOut => {
      if(loggedOut){
        this.logout();
      }
    });
    this.homepageService.isLogin$.subscribe(resultList => {
      this.isLogin = resultList;
      this.checkPatron();
      this.init();
    });
  }

  init(){
    if (localStorage.getItem('info')){
      this.isLogin = true;
      //this.profileDetail = JSON.parse(this.cookieService.get( 'info'));
      this.profileDetail = JSON.parse(localStorage.getItem('info'));
      if(this.profileDetail.detail.permission.opacAdmin){
            this.document.body.classList.add('login-patron');            
       }
    }  else {
      this.profileDetail.detail = [];
    }
    if( this.cookieService.check( 'MyLIstCount')){
      this.totalIds = this.cookieService.get( 'MyLIstCount');
      
      //console.log("my list oninit =="+ this.totalIds);
    }
    var currentList = parseInt($('#myCollectionLi').find('span.count').text());
      if(this.profileDetail?.detail?.permission?.opacPublishResourceList && currentList > 0){
        $('#Publish-My-List').removeClass('show').addClass('hide');
      }
    this.recentSearchCount = this.cookieService.get( 'recentSearchCunt'); 
    this.gloalSetting =   this.homepageService.getUpdatedConfig(); 
    
  }

  showMyMenuOptions : boolean = false;
  ngOnInit() {

    this.screenWidth = window.innerWidth;  
    this.screenHeight = window.innerHeight; 
    if(this.screenWidth >= 991){
      $('#libraryCard').css('display:none!important');
    }
    else{
      $('#library-profile').css('display:none!important');
    }
 
    this.checkPatron();
    this.init()
  }

  checkPatron(){
    if( this.cookieService.check( 'patron')){
      this.isUserLogin = true;
    } else {
      this.isUserLogin = false;
    }
  }

  ngAfterViewInit() {
    this.activatedRoute.queryParams.subscribe(params => {
      if(typeof(params.error) != 'undefined' && params.error == 'googleLoginAborted'){
        setTimeout(function(){
          var button = $("a#loginLia");
          button[0].click();
        },1000);
      }
    });
  }

  ngOnChanges(changes: any) {
    if(changes.googleError.currentValue != ''){
      setTimeout(function(){
        var button = $("a#loginLia");
        button[0].click();
        $('#loginError').text(changes.googleError.currentValue);
      },1000);
    }
  }
  
  changeLocation(location) {
    var key = 'selectedlocation' + this.gloalSetting.data.tenantCode.toLowerCase();
    this.cookieService.set(key, location, 1, '/');
    this.homepageService.setLocationId(location);
    var pagePath = window.location.href;
    if (pagePath.indexOf('/searchlist') == -1) {
      sessionStorage.setItem('lastSearchLocation', location);
    }
  }

 editLogobanner(event){

  var originImage = $.trim($('#origin-logo').val().toString());
  if(originImage != ''){
    $('.editwidgets-book.logo').find('.regularImage').attr('src',originImage);
    $('.editwidgets-book.logo').removeClass('removedImage').addClass('haveImage');
  }
  if($(event.target).hasClass('editLogobanner')){
    $(event.target).toggleClass('open').next('.editLogobannerContent').toggleClass('open');
  } else {
    $(event.target).parent().toggleClass('open').next('.editLogobannerContent').toggleClass('open');
  }
  
 }

 showProfileMenuFn(){
  if($('#profileLi').hasClass('open') ){
    $('#profileLi').removeClass('open');
    this.showProfileMenu = false;
    } else {
      $('#profileLi').addClass('open');
      $('#myCollectionLi').find('.dropdown-info.myList').removeClass('show').addClass('hide');
      this.showProfileMenu = true;      
    }
 }

 logout(){
  this.cookieService.deleteAll('/');
   $('li#loginLi').addClass('show').removeClass('hide');
   $('li#profileLi').removeClass('show').addClass('hide');
  $('li#myCollectionLi').removeClass('show').addClass('hide');
  localStorage.removeItem('info');
  this.document.body.classList.remove('login-patron');
  localStorage.removeItem('selectedResourcesIds');
  localStorage.removeItem('token');
  localStorage.removeItem("Session-Id");
  window.location.href = "/";
  //this.router.navigate(['/']);
 }



  removeImage(event, inputId){
    $(event.target).parents('.editwidgets-book').removeClass('haveImage').addClass('removedImage');
    $('#'+inputId).val('');
    $('#origin-logo').val('');
  }


  selectLogo(event){
    var selectImage = $(event.target).attr('src');
    $('#origin-logo').val(selectImage);
    $(event.target).parents('ul').find('li').removeClass('selected');
    $(event.target).parent().addClass('selected');
    $('.editwidgets-book.logo').find('.regularImage').attr('src',selectImage);
    $('.editwidgets-book.logo').removeClass('removedImage').addClass('haveImage');
    $('#closeLogoChoose').trigger('click');
  }

   visibleChoseLogo(){
    this.noUploadedLogo = false;
    //if(this.cookieService.check( 'info')){
    if (localStorage.getItem('info')){
      var token =  localStorage.getItem('token');
    }
    this.widgetSettingsService.logoListGet(token).subscribe((data) => {
      this.logoChoose = data;         
      this.logoChooseShow = true;
      if(data.data.length > 0){

      } else {
        this.noUploadedLogo = true;
      }
    });    
   }

  uploadImage(files: FileList) {
    $('#saveLogo').attr('disabled','disabled');
    $('#cancelLogo').attr('disabled','disabled');
    //if(this.cookieService.check( 'info')){
    if (localStorage.getItem('info')){
      var token =  localStorage.getItem('token');
    }
    this.fileToUpload = files.item(0);
    var validImageTypes = ["image/gif", "image/jpeg", "image/png", "image/jpg"];
    var fileType = this.fileToUpload.type;
    var fileSizeTemp = this.fileToUpload.size;
    var fileSize = Math.round((fileSizeTemp)/(1024*1024));
    if ($.inArray(fileType, validImageTypes) < 0) {
      this.imageError = 'Please use "jpeg", "jpg", "png" or "gif" image formats only.';
      $('#imageError').addClass('show');
      $('#saveLogo').removeAttr('disabled');
      $('#cancelLogo').removeAttr('disabled');
      return false;
    }
    if(fileSize >= 3){
      this.imageError = 'Image size should be less than 3 MB.';
      $('#imageError').addClass('show');
      $('#saveLogo').removeAttr('disabled');
      $('#cancelLogo').removeAttr('disabled');
      return false;
    }
    let formData = new FormData(); 
    formData.append('file', this.fileToUpload, this.fileToUpload.name); 
    this.widgetSettingsService.logoUpload(token,formData).subscribe((data) => {
      if(data.status){
        $('.editwidgets-book.logo').find('.regularImage').attr('src',data.data.links);
        $('#origin-logo').val(data.data.link);
        this.saveLogoSection($('#origin-logo'));
      }
    }, (error) => {
      this.notifier.notify( 'error', "Sorry! Something isn't working as expected." );
      $('#saveLogo').removeAttr('disabled');
      $('#cancelLogo').removeAttr('disabled');
    });
  }

  saveLogoSection(event){
    $('#saveLogo').text('Saving...').attr('disabled','disabled');
    $('#cancelLogo').attr('disabled','disabled');
    var line1 = $('#logoLine1').val();
    var line2 = $('#logoLine2').val();
    var image = $('#origin-logo').val();
    //if(this.cookieService.check( 'info')){
    if (localStorage.getItem('info')){
      var token =  localStorage.getItem('token');
    }
    this.widgetSettingsService.saveLogoSection(true,line1,line2,image,token).subscribe((data) => {
      this.homepageService.getConfig().subscribe((data) => {
        this.gloalSetting = data;
        $('#saveLogo').text('Save').removeAttr('disabled');
        $('#cancelLogo').removeAttr('disabled');
        $('.editLogobanner.logo').toggleClass('open').next('.editLogobannerContent').toggleClass('open');
      });      
    }); 
  }

   showMyListOptions(event){
    if($('#myCollectionLi').find('.dropdown-info.myList').hasClass('show') ){
      $('#myCollectionLi').find('.dropdown-info.myList').removeClass('show').addClass('hide');
    } else {
      $('#myCollectionLi').find('.dropdown-info.myList').addClass('show').removeClass('hide');
      $('#profileLi').removeClass('open');
    }
   }

  showDeleteConfirmation() {
    this.showDeleteConfirm = true;
  }

  hideDeleteConfirmation() {
    this.showDeleteConfirm = false;
  }

 emptyList() {
   this.showDeleteConfirm = false;
   this.cookieService.delete( 'tempPersonalCollection');
   this.cookieService.delete( 'MyLIstCount');
   $('.onViewList').removeClass('show').addClass('hide');
   $('#Publish-My-List').removeClass('show').addClass('hide');
    this.showMyListop = false;
    //if(this.cookieService.check( 'info')){
    if (localStorage.getItem('info')){
      var token =  localStorage.getItem('token');
    }
    if(token != null && typeof(token) != 'undefined' ){
      this.homepageService.clearListLogin(token).subscribe((data) => {
        if(data.status){
          localStorage.removeItem('selectedResourcesIds');
          $('#myCollectionLi').find('span.count').text('0');
          $('.book-box-bottom').each(function(){
            $(this).find('.btn-dander').removeClass('show').addClass('hide');  
            $(this).find('.btn-dander').prev('.btn.btn-primary').removeClass('hide').addClass('show');  
          });
          $('.book-box-bottom-btn').each(function(){
            $(this).find('.btn-dander').removeClass('show').addClass('hide');  
            $(this).find('.btn-dander').prev('.btn.btn-primary').removeClass('hide').addClass('show');  
          });
          $('#myCollectionLi').removeClass('show').addClass('hide');
          if(window.location.pathname == '/list/my'){
            this.router.navigate(['/']);
          }
        }
      });
    } else {
      localStorage.removeItem('selectedResourcesIds');
      $('#myCollectionLi').find('span.count').text('0');
      $('.book-box-bottom').each(function(){
        $(this).find('.btn-dander').removeClass('show').addClass('hide');  
        $(this).find('.btn-dander').prev('.btn.btn-primary').removeClass('hide').addClass('show');  
      });
      $('.book-box-bottom-btn').each(function(){
        $(this).find('.btn-dander').removeClass('show').addClass('hide');  
        $(this).find('.btn-dander').prev('.btn.btn-primary').removeClass('hide').addClass('show');  
      });      
      $('.book-box-bottom').find('.btn-dander').removeClass('show').addClass('hide');
      if(window.location.pathname == '/list/my'){
        this.router.navigate(['/']);
      }
      $('#myCollectionLi').removeClass('show').addClass('hide');
    }

  }


  getPublishedReadingLists(){
    this.PulishFormReady = false;
    this.publishResourceStatus = false;
    this.publishToOptionShow = false;
    this.publishDescriptionStatus = true;
    this.publishResourceName = '';
    this.publishResourceConfirure = null;
    this.publishResourceDescription = '';
    this.publishResourceImage = '';
    //if(this.cookieService.check( 'info')){
    if (localStorage.getItem('info') ){
      var token =  localStorage.getItem('token');
    }
    
    if(this.cookieService.check('userDetail')){
      var detail = JSON.parse(this.cookieService.get('userDetail'));
      this.patronId = detail.patronId;
      this.patronName = detail.firstName+ ' ' +detail.lastName;     
    }
    this.homepageService.getPublishedReadingLists(token).subscribe((list) => {        
      this.publishToListlist = list.data;
    });
    this.homepageService.getConfig().subscribe((data) => {  
      this.PulishFormReady = true;
      var tenant = data.data.tenantCode.toLowerCase(); 
      var selectedId =  this.cookieService.get('selectedlocation'+tenant)
      this.totalLocations = data.data.settings.location.locations.length;
      data.data.settings.location.locations.forEach( (loc) => {
       
        if(loc.id == selectedId){
          this.curentLoc['id'] = loc.id;
          this.curentLoc['name'] = loc.name;
        }
      });
      $('#publishToChange').trigger('change');
    });    
  }

  publishToChange(option){
    this.publishResourceStatus = true;
    if(option != '') {
      this.publishToOptionShow = true;
      //if(this.cookieService.check( 'info')){
      if (localStorage.getItem('info') ){
        var token =  localStorage.getItem('token');
      }
      this.homepageService.getReadingListsDetail(option, token).subscribe((detail:any) => {
        this.publishResourceName = detail.data.name;
        this.publishResourceConfirure = detail.data.configurationId;
        this.publishResourceDescription = detail.data.description;
        this.publishResourceImage = detail.data.imageUrl;
        this.publishResourceStatus = false;
      });
    } else {
      this.publishToOptionShow = false;
      this.publishResourceName = '';
      this.publishResourceConfirure = null;
      this.publishResourceDescription = '';
      this.publishResourceImage = '';
      this.publishResourceStatus = false;
    }
    var listType = $('#publishToChange option:selected').attr('listType');
    if(listType == 'P' || listType == 'N'){
      this.publishDescriptionStatus = false;
    } else {
      this.publishDescriptionStatus = true;
    }
  }

savePublishToList(){

  var error:number = 0;
  var listType = $('#publishToChange option:selected').attr('listType');
  var existingCollectionId = $('#publishToChange').val();
  var operation = $('input[name="add_to"]:checked').val();
  var resourceIds = JSON.parse(localStorage.getItem('selectedResourcesIds'));
  var name = $.trim($('#publishResourceName').val().toString() );
  if(name == '' && listType != 'N' && listType != 'P'){
    $('#publishResourceName').addClass('error');
    $('#publishResourceName').after('<small class="error">Title is required.</small>');
    error++;
  }
  var imageUrl = $('#publishResourceImage').val();
  var locationId = $('input[name="PublishselectLocation"]:checked').val();
  var description = $.trim($('#publishResourceDescription').val().toString() );
  if(description == '' && listType != 'N' && listType != 'P'){
    $('#publishResourceDescription').addClass('error');
    $('#publishResourceDescription').after('<small class="error">Description is required.</small>');
    error++;
  }
  var auth = localStorage.getItem('token');
  if(error > 0){
    $('.submit-btn').attr('disabled','disabled');
    setTimeout(function(){
      $('#Publish-My-List-Modal').find('small.error').remove();
      $('#Publish-My-List-Modal').find('.error').removeClass('error');
      $('.submit-btn').removeAttr('disabled');
    },3000);
    return false;
  }
  this.publishResourceStatus = true;
  if(listType == 'R'){
    this.homepageService.publishToreadingList(existingCollectionId, operation, resourceIds, name,description,imageUrl,locationId, auth).subscribe((data:any) => {
      if(data.status){
        this.notifier.notify( 'success', data.message );
        $('#PublishMyListModalClose').trigger('click');
        this.router.navigate(['/']);
      }
      this.publishResourceStatus = false;
    });
  } else if(listType == 'N' || listType == 'P'){
    this.homepageService.publishToNewInLibrary(existingCollectionId, operation, resourceIds, name, auth).subscribe((data:any) => {
      if(data.status){
        this.notifier.notify( 'success', data.message );
        $('#PublishMyListModalClose').trigger('click');
        this.router.navigate(['/']);
      }
      this.publishResourceStatus = false;
    });
  } else if(listType == 'A'){
    this.homepageService.publishToNewList(resourceIds, name,description,imageUrl,locationId, auth).subscribe((data:any) => {
      if(data.status){
        this.notifier.notify( 'success', data.message );
        $('#PublishMyListModalClose').trigger('click');
        this.router.navigate(['/']);
      }
      this.publishResourceStatus = false;
    });
  }
}

uploadImagePublish(files: FileList) {
  this.publishResourceStatus = true;
  this.fileToUpload = files.item(0); 
  let formData = new FormData();
  var validImageTypes = ["image/gif", "image/jpeg", "image/png", "image/jpg"];
  var fileType = this.fileToUpload.type;
  if ($.inArray(fileType, validImageTypes) < 0) {
    this.imageError = 'Please use "jpeg", "jpg", "png" or "gif" image formats only.';
    this.publishResourceStatus = true;
    return false;
  }
  formData.append('file', this.fileToUpload, this.fileToUpload.name); 
  //if(this.cookieService.check( 'info')){
  if (localStorage.getItem('info') ){
    var token =  localStorage.getItem('token');
  }
  this.homepageService.readingListImageUpload(formData, token).subscribe((data : any) => { 
    this.publishResourceStatus = false;
    $('#publishResourceImage').attr('value',data.data.url);
    $('#publishResourceImage').parent().addClass('haveImage');
    $('#publishResourceImage').parent().find('img.regularImage').removeClass('hide').removeClass('show').attr('src',data.data.url);
  });
 }

 closeImageError(){
  $('#imageError').removeClass('show');
  this.imageError = '';
 }

 
 getLibraryCardDetail(){
  this.homepageService.getLibraryCard().subscribe((data:any)=>{
    this.libraryCard = data.data;
    this.dateFormat = this.homepageService.formatDate();
    this.colors = this.homepageService.bgColor(data.data.number);
    this.patronName = data.data.firstName+ ' ' +data.data.lastName;   
    this.imageName = this.homepageService.initialName(this.patronName);
    return this.libraryCard;
  },(error)=>{
    this.notifier.notify( 'error', "Something went wrong.");
  });
}



}
